import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Añade autenticación a las peticiones de la API v1 (/api/v1):
 *   - Authorization: Bearer <token> (token desde localStorage)
 *   - Content-Language: es
 *
 * No toca el backend PHP ni servicios externos.
 */
@Injectable()
export class BearerAuthInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!req.url.includes('/api/v1')) {
            return next.handle(req);
        }

        const token = localStorage.getItem('token') || '';
        const setHeaders: Record<string, string> = {
            'Content-Language': 'es',
        };
        if (token && !req.headers.has('Authorization')) {
            setHeaders['Authorization'] = `Bearer ${token}`;
        }

        return next.handle(req.clone({ setHeaders }));
    }
}
